module.exports = __webpack_public_path__ + "static/media/Query_white.1994eedc.svg";